import { shopApi } from '../api';

export const shopRepo = {
    getAll: (params) => shopApi.getAll(params),
    getById: (shopId) => shopApi.getById(shopId),
    create: (data) => shopApi.create(data),
    register: (data) => shopApi.register(data),
    update: (shopId, data) => shopApi.update(shopId, data),
    toggleStatus: (shopId) => shopApi.toggleStatus(shopId),
    getTypes: () => shopApi.getTypes(),
};